import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchFormData, fetchData } from "../../utils/options";
import topTost from "../../utils/topTost";
import { BaseUrl } from "../..";
const PackageCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    package_name: "",
    price: "",
    validity_period: "",
    status: "1",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    if (key === "price") {
      value = value.replace(/[^0-9.]/g, "");
      const parts=value.split(".")
    // Limit digits before decimal to 3-5
    if (parts[0].length > 5) parts[0] = parts[0].slice(0, 5);

    // Limit digits after decimal to 2
    if (parts[1]?.length > 2) parts[1] = parts[1].slice(0, 2);

    // Join back
    value = parts[1] !== undefined ? `${parts[0]}.${parts[1]}` : parts[0];
    } else if (key === "validity_period") {
      value = value.replace(/\D/g, "");
      if(value.length>3) value=value.slice(0,3)
    }

    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchAllDetails = async (id) => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      const result = await fetchFormData(`package-getbyid`, formData, "POST");

      if (result?.code === 200) {
        const d = result.data;

        setFormData({
          id: d.id,
          package_name: d.package_name || "",
          price: d.price || "",
          validity_period: d.validity_period || "",
          status: d.status?.toString() || "1",
        });
      } else {
        topTost({ title: "Course not found", icon: "warning" });
      }
    } catch (error) {
      console.log("Fetch error:", error);
      topTost({ title: "Server error", icon: "error" });
    }
  };

  useEffect(() => {
    if (id) {
      fetchAllDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value ?? "");
    });

    try {
      // Manually fetch the data instead of using fetchFormData (only here)
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        id ? `${BaseUrl}edit-package` : `${BaseUrl}add-package`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        }
      );
      const data = await response.json();
      const result = data.result;
      if (!result) return;
      // Validation error check
      if (result?.code=== 422 && result?.data) {
        const firstField = Object.keys(result.data)[0];
        const errorMsg = result.data[firstField][0];
        topTost({ title: errorMsg, icon: "error" });
        setIsSubmitting(false);
        return;
      }

      // Success check
      if (
        result?.success === "true" ||
        result?.success === true ||
        result?.code === 200 ||
        result?.code === "200"
      ) {
        topTost({
          title:
            result.message ||
            (id ? "Updated successfully!" : "Saved successfully!"),
          icon: "success",
        });
        setTimeout(() => {
           navigate("/master/package-list");
        }, 600);
       
        setIsSubmitting(false);
        return;
      }

      // Other errors
      topTost({
        title: result?.message || "Error submitting form",
        icon: "error",
      });
    } catch (error) {
      topTost({ title: "Error submitting form", icon: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Package:" : "Add Package:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              <Input
                label="Package Name"
                name="package_name"
                placeholder="Enter Package Name"
                value={formData.package_name}
                onChange={handleChange}
                icon="feather-hash"
                required
              />
              <Input
                label="Price"
                name="price"
                placeholder="Enter Price"
                value={formData.price}
                onChange={handleChange}
                icon="feather-cash"
                required
              />
              <Input
                label="Validity Days"
                name="validity_period"
                placeholder="Enter Validation Time"
                value={formData.validity_period}
                onChange={handleChange}
                icon="feather-tag"
                required
              />

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackageCreate;
